import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useInternalSideSheetContext } from '../SideSheet.Context/index.es.js';

const SideSheetFooter = ({ children })=>{
    const { hasFooterShadow } = useInternalSideSheetContext();
    return jsx("div", {
        className: classNames('cb-side-sheet-footer', {
            shadow: hasFooterShadow
        }),
        "data-testid": "side-sheet-footer",
        children: children
    });
};
SideSheetFooter.displayName = 'SideSheet.Footer';

export { SideSheetFooter };
//# sourceMappingURL=SideSheet.Footer.es.js.map
